import {interpolateText} from 'cms/utils/interpolate-utils';
import {useSelector} from 'react-redux';

const usePrismicInterpolateText = () => {
    const interpolations = useSelector(state => state.cms.interpolations);
    const interpolate = text => interpolateText(text, interpolations);

    return {
        interpolate,
    };
};

export default usePrismicInterpolateText;
